module.exports = __webpack_public_path__ + "img/time.fdae221a.png";